import './styles.css';
import { mount, clear } from '@ui/dom';
import { onRouteChange, startRouter } from '@ui/router';
import { renderLobby } from '@ui/lobby';
import { renderSetup } from '@ui/setup';
import { renderPlay } from '@ui/play';
import { showConsentBanner } from '@ui/privacy';
import { registerGame } from '@core/game-registry';
import { setLang, getLang } from '@core/i18n';
import { globeGame } from '@games/globe';
import { animalsGame } from '@games/animals';

// Init lingua
setLang(getLang());

// Registra giochi (cuore dell'estendibilità: aggiungere qui altri moduli)
registerGame(globeGame);
registerGame(animalsGame);

const app = document.getElementById('app')!;

onRouteChange(async (route) => {
  clear(app);
  app.append(document.createTextNode('…'));
  let view: HTMLElement;
  try {
    if (route.name === 'lobby') view = await renderLobby();
    else if (route.name === 'setup') view = renderSetup(route.gameId);
    else view = await renderPlay(route.gameId, route.sessionId);
  } catch (e) {
    console.error(e);
    view = document.createElement('div');
    view.className = 'p-6 text-rose-300';
    view.textContent = `Errore: ${(e as Error).message}`;
  }
  mount(app, view);
});

startRouter();
showConsentBanner();
